"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6034],{

/***/ 89514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useWindowHook = function useWindowHook() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)( true ? window.innerWidth : 0),
      screenWidth = _useState[0],
      setScreenWidth = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var handleResize = function handleResize() {
      setScreenWidth(window.innerWidth);
    };

    var debouncedHandleResize = debounce(handleResize, 100); // Debounce resizing

    window.addEventListener('resize', debouncedHandleResize); // Initial setting of screenWidth

    handleResize();
    return function () {
      return window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);
  var isMobile = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return screenWidth < 1024;
  }, [screenWidth]);

  var closeWindowTabWithTimeout = function closeWindowTabWithTimeout() {
    setTimeout(function () {
      window.opener = null;
      window.open('', '_self');
      window.close();
    }, 8000);
  };

  return {
    screenWidth,
    isMobile,
    closeWindowTabWithTimeout
  };
};

function debounce(func, wait) {
  var timeout;
  return function executedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var later = function later() {
      clearTimeout(timeout);
      func.apply(void 0, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useWindowHook);

/***/ }),

/***/ 55145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _context_store_useBrandConfigStore_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78525);


var _require = __webpack_require__(14671),
    create = _require.create;

var usePopupNoticeBoardStore = create(function (set) {
  return {
    openPopupNoticeBoard: false,
    setOpenPopupNoticeBoard: function setOpenPopupNoticeBoard() {
      var _config$bannerPopUp;

      var _useBrandConfigStore$ = _context_store_useBrandConfigStore_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState(),
          config = _useBrandConfigStore$.config;

      var bannerPopupBrand = config === null || config === void 0 ? void 0 : (_config$bannerPopUp = config.bannerPopUp) === null || _config$bannerPopUp === void 0 ? void 0 : _config$bannerPopUp.bannerPopUp;
      var newOpen = bannerPopupBrand !== null && bannerPopupBrand !== void 0 && bannerPopupBrand.isActive ? (bannerPopupBrand === null || bannerPopupBrand === void 0 ? void 0 : bannerPopupBrand.isActive) === 'active' : false;
      set({
        openPopupNoticeBoard: newOpen
      });
    },
    setClosePopupNoticeBoard: function setClosePopupNoticeBoard() {
      set({
        openPopupNoticeBoard: false
      });
    }
  };
});
/* harmony default export */ __webpack_exports__["Z"] = (usePopupNoticeBoardStore);

/***/ }),

/***/ 6034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hocs_withMemo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56118);
/* harmony import */ var _hooks_useWindowHook_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89514);
/* harmony import */ var _hooks_useRouterHook_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3780);
/* harmony import */ var _organism_PopupNoticeBoard_hooks_usePopupNoticeBoardStore_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55145);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);



 // import useBrandConfigStore from '../../../../context/store/useBrandConfigStore.store';

 // import Sidebar from '../../organism/Sidebar';
// import PopupNoticeBoard from '../../organism/PopupNoticeBoard';
// import Sidebar from '../../organism/Sidebar';
// import NavbarMobile from '../../organism/NavbarMobile';
// import Header from '../../organism/Header/Header';
// import Container from '../../organism/Container';
// import Footer from '../../organism/Footer';
// import PopupNoticeBoard from '../../organism/PopupNoticeBoard';
// import BannerMainOut from '../../molecules/Banner/BannerMainOut';
// import BannerGameCategory from '../../pages/GamesPage/components/BannerGameCategory';
// import GameSearchPageComponent2 from '../../molecules/GameSearchComponent/components/GameSearchPageComponent2';
// import LayoutModal from '../../../features/modal/LayoutModal';
// import HeadLayout from '../HeadLayout';
// import ScriptLayout from '../ScriptLayout';
// import BannerGameCategory from '../../pages/GamesPage/components/BannerGameCategory';




var Chat = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4938), __webpack_require__.e(5624), __webpack_require__.e(3242)]).then(__webpack_require__.bind(__webpack_require__, 53242));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(53242)];
    }
  }
});
var Sidebar = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(4938), __webpack_require__.e(2822), __webpack_require__.e(6860), __webpack_require__.e(4854)]).then(__webpack_require__.bind(__webpack_require__, 44854));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(44854)];
    }
  }
});
var NavbarMobile = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(4938), __webpack_require__.e(8043), __webpack_require__.e(2822), __webpack_require__.e(6860), __webpack_require__.e(8230)]).then(__webpack_require__.bind(__webpack_require__, 15066));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(15066)];
    }
  }
});
var Header = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(4938), __webpack_require__.e(341)]).then(__webpack_require__.bind(__webpack_require__, 10341));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(10341)];
    }
  }
});
var Container = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return __webpack_require__.e(/* import() */ 8505).then(__webpack_require__.bind(__webpack_require__, 88505));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(88505)];
    }
  }
});
var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(6794)]).then(__webpack_require__.bind(__webpack_require__, 46794));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(46794)];
    }
  }
});
var PopupNoticeBoard = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4938), __webpack_require__.e(2822), __webpack_require__.e(6860), __webpack_require__.e(9578)]).then(__webpack_require__.bind(__webpack_require__, 49578));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(49578)];
    }
  }
});
var BannerMainOut = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8043), __webpack_require__.e(2229)]).then(__webpack_require__.bind(__webpack_require__, 10509));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(10509)];
    }
  }
});
var BannerGameCategory = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return __webpack_require__.e(/* import() */ 8165).then(__webpack_require__.bind(__webpack_require__, 38165));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(38165)];
    }
  }
});
var GameSearchPageComponent2 = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7154), __webpack_require__.e(5675), __webpack_require__.e(4938), __webpack_require__.e(2822), __webpack_require__.e(6860), __webpack_require__.e(5266), __webpack_require__.e(7402)]).then(__webpack_require__.bind(__webpack_require__, 97402));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(97402)];
    }
  }
});
var LayoutModal = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return __webpack_require__.e(/* import() */ 6535).then(__webpack_require__.bind(__webpack_require__, 76535));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76535)];
    }
  }
});
var HeadLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return __webpack_require__.e(/* import() */ 7696).then(__webpack_require__.bind(__webpack_require__, 97696));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(97696)];
    }
  }
});
var ScriptLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(function () {
  return __webpack_require__.e(/* import() */ 925).then(__webpack_require__.bind(__webpack_require__, 10925));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(10925)];
    }
  }
});

function Layout(_ref) {
  var children = _ref.children;

  var _usePopupNoticeBoardS = (0,_organism_PopupNoticeBoard_hooks_usePopupNoticeBoardStore_store__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function (state) {
    return {
      openPopupNoticeBoard: state.openPopupNoticeBoard
    };
  }),
      openPopupNoticeBoard = _usePopupNoticeBoardS.openPopupNoticeBoard;

  var _useRouterHook = (0,_hooks_useRouterHook_hook__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      router = _useRouterHook.router;

  var _useWindowHook = (0,_hooks_useWindowHook_hook__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      isMobile = _useWindowHook.isMobile;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: "overflow-auto",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(HeadLayout, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ScriptLayout, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Chat, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(LayoutModal, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Header, {}), isMobile ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(NavbarMobile, {}) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "flex flex-col bg-container-bg-primary text-text-color-primary",
        children: [openPopupNoticeBoard && router.asPath === '/' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(PopupNoticeBoard, {}), router.asPath.startsWith('/games') && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(BannerGameCategory, {}), router.asPath === '/' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(BannerMainOut, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "flex justify-center relative flex-grow",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Container, {
            children: children
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Sidebar, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(GameSearchPageComponent2, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Footer, {})]
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = ((0,_hocs_withMemo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Layout));

/***/ }),

/***/ 56118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * A wrapper function for React.memo with additional functionality.
 * @param {React.ComponentType} Component - The component to be memoized.
 * @param {Function} [areEqual] - Optional custom comparison function.
 * @returns {React.MemoExoticComponent} - The memoized component.
 */

var withMemo = function withMemo(Component, areEqual) {
  var MemoizedComponent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Component, areEqual); // Additional functionality or logging can be added here if needed.

  return MemoizedComponent;
};

/* harmony default export */ __webpack_exports__["Z"] = (withMemo);

/***/ })

}]);